import {
  AgentAttendanceDetailsShiftPositionsInner,
  AgentAttendanceShortShiftPositionsInner,
} from 'modules/Monitoring/types'

import { AgentAttendanceShiftState } from '../types'

import { getShiftPositionStatus } from './getShiftPositionStatus'

type PositionType =
  | AgentAttendanceDetailsShiftPositionsInner
  | AgentAttendanceShortShiftPositionsInner

export const getCurrentShiftPosition = <T extends PositionType>(
  positions: T[],
): { activePosition: T | undefined; currentPosition: T | undefined } => {
  const activePosition = positions.find(
    position => getShiftPositionStatus(position) === AgentAttendanceShiftState.Active,
  )
  const firstProductivePosition = positions.find(position => position.productive)
  const currentPosition = activePosition ?? firstProductivePosition

  return {
    activePosition,
    currentPosition,
  }
}
